<template>
  <validation-observer ref="form">
    <div class="mt-2">
      <div class="d-flex">
        <i class="fas fa-ban text-orange mr-2 mt-1"></i>
        <p class="font-weight-normal font-18">
          Dejar sin Acción
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="comment"
            :label="'Comentario'"
            placeholder="Escriba un comentario..."
            custom-error-msg="Campo requerido"
            class="w-100 pl-2"
            :error="errors[0]"
            :maxlength="3000"
          />
        </validation-provider>
      </div>
    </div>

    <div class="row">
      <div class="col-12 d-flex justify-content-end mt-4">
        <action-button
          type="button"
          :text="isReadOnly ? 'Cerrar' : 'Cancelar'"
          i="fas fa-times-circle"
          variant="outline-danger"
          :class="{ 'mr-2': !isReadOnly }"
          @click="$emit('cancel')"
        />
        <action-button
          v-if="!isReadOnly"
          type="button"
          text="Guardar"
          i="fas fa-save"
          variant="success"
          @click="save"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';

export default {
  name: 'DisabledAction',
  components: {
    CustomTextArea,
    ActionButton,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      comment: null,
    };
  },
  methods: {
    async save() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;
      this.$emit('save', this.comment);
    },
  },
};
</script>
